import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsDmConstants {
    static TYPE_CTRL = "type";
    static DESCRIPTION_CTRL = "description";
    static TYPE_LBL = "Application type";
    static DESCRIPTION_LBL = "Description";
    static APPLICATION_PLACE_HOLDER = "Application place holder";
    static VALIDATION_MESSAGES = {
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
